var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"result-list-container"},[_vm._v(" To do: Legal Disclaimer text ")])}
var staticRenderFns = []

export { render, staticRenderFns }